export default __webpack_public_path__ + "static/The-world-traveller-who-never-left-home-c3ec5915d7197022768b9d38ff672882.jpg";